<template>
  <form action="">
    <div class="search-head__wrapper">
      <!-- <div class="cat cat-search">
          <input type="text" placeholder="Search" name="" id="" class="input-text">
        </div>-->
      <!-- Category select - Cat -->
      <div  v-if="eventname === 'wuc'" class="cat cat-select" >
        <select name="" class="input-text" id="countryName" v-model="selectedCountry">
          <option value="">Country Name</option>
          <option v-for="country in countries" :value="country.Text" :key="country.Text">{{
            country.Text }}</option>
        </select>
      </div>
      <div v-else class="cat cat-select">
        <select name="" class="input-text" id="countryName" v-model="selectedCountry">
          <option value="">Country Name</option>
          <option v-for="country in countries" :value="country.CountryPavilion" :key="country.CountryPavilion">{{
            country.CountryPavilion }}</option>
        </select>
      </div>


      <div  v-if="eventname === 'wuc'"  class="cat cat-select">
        <select name="" class="input-text" id="productCategory" v-model="selectedProduct">
          <option value="">Select Category</option>
          <option v-for="product in productCategories" :value="product.Value"
            :key="product.Text">{{ product.Text }}
          </option>
        </select>
      </div>
      <div v-else class="cat cat-select">
        <select name="" class="input-text" id="productCategory" v-model="selectedProduct">
          <option value="">Select Category</option>
          <option v-for="product in productCategories" :value="product.ProductCategories"
            :key="product.ProductCategories">{{ product.ProductCategories }}
          </option>
        </select>
      </div>



      <div class="cat cat-search">
        <input type="text" placeholder="Company Name" class="input-text" id="companyName" v-model="companyName">
      </div>
      <div class="cat cat-search">
        <input type="text" placeholder="Stand Number" class="input-text" id="StandNumber" v-model="standNumber">
      </div>
      <div class="cat cat-input-button">
        <div class="btn-secondary" v-on:click="filtering(eventname)"> <a href="javascript:void(0)"> search</a>
        </div>
        <div class="btn-primary" v-on:click="Reset"> <a href="javascript:void(0)">Reset</a>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import axios from "axios";
import url from "./../../config/url";
export default {
  name: "DropDownFilter",
  data: function () {
    return {
      selectedProduct: "",
      selectedCountry: "",
      standNumber: "",
      companyName: "",
      countries: [],
      productCategories: [],
      exhibitors: []
    }; // initialize empty array
  },
  mounted() {
    const url = window.location.href;
    const domain = url.split('/')[2];
    if (domain === "www.japanenergyevent.com/") {
      this.eventname = "japan";
    } 
    else if (domain === "worldutilitiescongress.com") {
      this.eventname = "wuc";
    }
    else if (domain === "https://www.egyptminingforum.com/") {
      this.eventname = "emf";
    }
    else {
      this.eventname = "japan";
    }

    this.getCountries(this.eventname); // when the Vue app is booted up, this is run automatically.
    this.getproductCategories(this.eventname);
  },
  methods: {
    getCountries(eventname) {
      let apiUrl = eventname === "wuc"
        ? url.country_list_api_WUC
        : url.country_list_api(eventname);

      axios
        .get(apiUrl)
        .then(response => (this.countries = response.data))
        .catch({

        });
    },
    getproductCategories(eventname) {
      
      let apiUrl = eventname === "wuc"
        ? url.product_list_api_WUC
        : url.product_list_api(eventname);

      axios
        .get(apiUrl)
        .then(response => (this.productCategories = response.data))
        .catch({

        });
    },
    filtering: function (eventname) {
      let apiUrl = eventname === "wuc"
        ? url.filter_list_api_WUC
        : url.filter_list_api;
      axios
        .get(apiUrl, {
          params: {
            eventname: this.eventname,
            companyName: this.companyName,
            standNumber: this.standNumber,
            productCategory: this.selectedProduct,
            countryName: this.selectedCountry
          }
        })
        .then(response => {
          this.$store.commit("filteredExhibitor", response.data);
        })
        .catch({

        });
    },
    Reset: function () {
      this.companyName = null;
      this.standNumber = null;
      this.selectedProduct = "";
      this.selectedCountry = "";
      this.$store.dispatch("exhibitorInitialList", this.eventname);
    }
  }
};
</script>
<style></style>
